import React, { useEffect, useRef, useState } from "react";
import bookmarkIMG from "../images/bookmark.png";
import { FiCalendar } from "react-icons/fi";
import { BsFillBookmarkFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import BreadcrumbNav from "./BreadcrumbNav";
import { getbookmarkApi, setbookmarkApi } from "../store/actions/campaign";
import { translate } from "../utils";
import Skeleton from "react-loading-skeleton";

function BookmarkSection() {
    

const scrollToTop = () => {
    window.scrollTo({ top: 0 });
};
    const [Data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const initialData = useRef([]);

    useEffect(() => {
      initialData.current = Data;
    }, [Data]);

    // get bookmark
    useEffect(() => {
      getbookmarkApi(
        "0",
        "",
          (response) => {
              setData(response.data);
              setIsLoading(false);
        },
          (error) => {
              setIsLoading(false);
              if (error === "வேறு தகவல்கள் இல்லை") {
                setData("");
            }

        }
      );
    }, []);

    // set bookmark for remove bookmark
    const setbookmarkData = (e, newsid, status) => {
      e.preventDefault();
      setbookmarkApi(
        newsid,
        status,
          (response) => {
              setData(Data.filter((item) => item.news_id !== newsid));
              setIsLoading(false);
        },
        (error) => {
            setIsLoading(false);
            if (error === "வேறு தகவல்கள் இல்லை") {
                setData("");
            }
        }
      );
    };


    return (
        <>
            <BreadcrumbNav SecondElement="Bookmark" ThirdElement="0" />

            <div id="bs-main" className="my-3">
                    <div id="bs-content" className="container">
                        <div className="row">
                        {isLoading ? (
                            // Show skeleton loading when data is being fetched
                            <div className="col-12 loading_data">
                                <Skeleton height={20} count={22} />
                            </div>
                        ) : Data.length > 0 ? (
                            Data?.map((element) => (
                                <div className="col-lg-4 col-md-6 col-xl-3 col-12 mb-3 px-2" key={element.id}>
                                    <div id="bs-card" className="card h-100">
                                        <img id="bs-card-image" src={element.image} className="card-img" alt="..." />
                                        <div id="bs-card-body" className="card-body">
                                            <button id="bs-btnCatagory" className="btn btn-sm" type="button">
                                                {element.category_name}
                                            </button>
                                            <button id="bs-btnBookmark" className="btn" onClick={(e) => setbookmarkData(e, element.news_id, "0")}>
                                                <BsFillBookmarkFill id="bs-bookmark-logo" size={18} />
                                            </button>
                                            <h5 id="bs-card-title" className="card-title">
                                                {element.title.slice(0, 150)}...
                                            </h5>
                                            <p id="bs-card-date">
                                                <FiCalendar size={18} id="bs-logoCalendar" />
                                                {element.date.slice(0, 10)}
                                            </p>
                                            <Link onClick={() => scrollToTop()} id="Link-all " className="btn bs-ReadMore" to={"/news-view?Nid=" + element.news_id + "&Cid=" + element.category_id}>
                                                {translate("readmore")}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            // Show "வேறு தகவல்கள் இல்லை" message if no data is available
                            <div className="col-12 no_data mt-5">
                                <div id="bs-no-main">
                                    <img id="bs-no-image" src={bookmarkIMG} alt="" />
                                    <p id="bs-no-title">
                                        <b>{translate("addbookmark")}</b>
                                    </p>
                                    <p id="bs-no-text">{translate("dontforgetbookmark")}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default BookmarkSection;
